export const data = [
  {
    id: 0,
    name: "Ovo je demo tekst.Ovo je demo tekst.Ovo je demo tekst.Ovo je demo tekst.",
    check: false,
    data: [
      {
        id: 1,
        name: "Ovo je podtekst.Ovo je podtekst",
        data: [
          {
            id: 0,
            name: "Ovo je 2tekst.Ovo je 2tekst",
            check: false,
            data: [
              {
                id: 1,
                name: "Ovo je 3tekst.Ovo je 3tekst",
                data: [
                  {
                    id: 0,
                    name: "Ovo je 4tekst.Ovo je demo 4tekst",
                    check: false,
                    data: [
                      {
                        id: 1,
                        name: "Ovo je 5tekst.Ovo je 5tekst",
                        data: [
                          {
                            id: 0,
                            name: "Ovo je demo 6tekst.Ovo je demo 6tekst",
                            check: false,
                            data: [
                              {
                                id: 1,
                                name: "Ovo je 7tekst.Ovo je 7tekst",
                                data: [],
                              },
                            ],
                          },
                          {
                            id: 0,
                            name: "Ovo je demo 6tekst.Ovo je demo 6tekst",
                            check: false,
                            data: [
                              {
                                id: 1,
                                name: "Ovo je 7tekst.Ovo je 7tekst",
                                data: [],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 0,
    name: "Ovo je demo tekst.Ovo je demo tekst.Ovo je demo tekst.Ovo je demo tekst.",
    check: false,
    data: [{ id: 1, name: "Ovo je podtekst.Ovo je podtekst", data: [] }],
  },
  {
    id: 0,
    name: "Ovo je demo tekst.Ovo je demo tekst.Ovo je demo tekst.Ovo je demo tekst.",
    check: false,
    data: [{ id: 1, name: "Ovo je podtekst.Ovo je podtekst", data: [] }],
  },
  {
    id: 0,
    name: "Ovo je demo tekst.Ovo je demo tekst.Ovo je demo tekst.Ovo je demo tekst.",
    check: false,
    data: [{ id: 1, name: "Ovo je podtekst.Ovo je podtekst", data: [] }],
  },
];
